import ReportIcon from '@material-ui/icons/Assignment';
import ExpireList from './ExpireList';
//import ScheduleEdit from './ScheduleEdit';
//import ScheduleCreate from './ScheduleCreate';
//import DonorView from './DonorView'

export default {
    list: ExpireList,
    /*show: DonorView,*/
    //edit: ScheduleEdit,
    //create: ScheduleCreate,
    icon: ReportIcon,
};
